export const MAX_TOP_SCROLLPOS = 105;
export const MAX_TOP_SCROLLPOS_MOBILE = 128;
export const OFFSET_BOTTOM = 85;

export const ELEMENTS = {
  a0: "productListTable",
  a1: "productListTableWrapper",
  a2: "productListTableHeadWrapper",
  b: "scrollableTableHeader",
  c: "fixedTableHeader"
};
